export const DRAG_HELPER_CLASS = 'drag-helper'
